import React from "react";
import AcxChip from "components/UI/AcxChip";

/**
 * Marks a newly shipped surface, in the purple-to-teal gradient the design calls for. The gradient
 * itself lives on AcxChip as the `brandBlend` color, beside the palette's flat colors.
 *
 * Takes the same optional `infoText` hover explanation as {@link AcxDeprecatedTag} so a caller
 * rendering whichever tag a surface declares never silently drops the message. Omit it and the
 * chip renders bare.
 *
 * No removal trigger: dropping the tag when it stops being new is a deliberate edit, not something
 * this component decides.
 */
export const AcxNewTag = ({ infoText }: { infoText?: string }) => (
    <AcxChip
        size="small"
        color="brandBlend"
        label="New"
        customTooltip={infoText}
        sx={{ marginBottom: 0 }}
    />
);

export default AcxNewTag;
